const paginationBuilder = (postType, currentPage, lastPage, midsize = 1) => {
    const current = parseInt(currentPage);
    const last = parseInt(lastPage);
    const mid = parseInt(midsize);
    const html = [];
    const range = [];


    if (current >= 1 && last > 1 && current <= last) {
        for (let i = Math.max(2, current - mid); i <= Math.min(last - 1, current + mid); i++) {
            range.push(i);
        }

        if (current - mid > 2) {
            range.unshift('...');
        }

        if (current + mid < last - 1) {
            range.push('...');
        }

        range.unshift(1);
        range.push(last);

        // Create Pagination HTML
        range.map((item) => {
            if (typeof item !== 'string') {
                html.push(`<a data-post-type='${postType}' class='page-numbers${item === current ? ' current' : ''}' href='#' data-page='${item}'>${item}</a>`);
            } else {
                html.push(`<span class='page-numbers dots'>${item}</span>`);
            }
        });
    }

    return html.join('');
}

export default paginationBuilder;
